import { notFound } from "next/navigation";
import { getRequestConfig } from "next-intl/server";

// Can be imported from a shared config
export const locales = [
  "en-US",
  "en-CA",
  "fr-CA",
  "en-AU",
  "en-NZ",
  "en",
  "fr"
];

export default getRequestConfig(async ({ locale }) => {
  // Validate that the incoming `locale` parameter is valid
  if (!locales.includes(locale as any)) notFound();

  return {
    messages: (await import(`./i18n/messages/${locale}.json`)).default
  };
});
